<template>
  <div class="wrapper">
    <div class="wrapper-description">
      <div class="content__description">
        <div class="description__wrapper">
          <div
            v-for="(item, index) in variantItemSlide"
            :key="`${item.id}`"
            @click="chooseFormat(item.type, index)"
            class="card"
            :class="{card_active: acitveTypeItemsIndex === index}"
          >
            <div class="number">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="title">{{ $t(item.title) }}</div>
            <div class="subtitle">{{ $t(item.subtitle) }}</div>
          </div>
        </div>
      </div>
      <div class="carousel-wrapper">
        <div
          class="carousel"
          @mousemove="dragging"
          @mousedown="dragStart"
          @mouseup="dragStop"
          @mouseleave="dragStop"
          @touchstart="dragStart"
          @touchmove="dragging"
          @touchend="dragStop"
          ref="videoSliderRef"
        >
          <div v-if="acitveTypeItems === 'video'" class="video">
            <div v-for="(video, index) in activeItemSlide">
              <div
                v-if="!isMobile"
                class="loader__wrapper"
                :key="video.src"
                :style="{
                left: `calc(${index * firstImgWidth + 'px'}`,
                zIndex: loadVideoForStart[
                  isMobile ? video.srcMobile : video.src
                ]
                  ? -1
                  : 1,
              }"
              >
                <UiLoader
                  :radius="10"
                  color="var(--var-blue-100)"
                  :circle-width="2"
                />
              </div>
            </div>
            <video
              v-for="(video, index) in activeItemSlide"
              :id="isMobile ? video.srcMobile : video.src"
              :key="video.src"
              :class="{
              'gallery-video-loop_first': index === 0,
              'gallery-video-loop': true,
            }"
              :controls="isMobile"
              autoplay
              autobuffer
              loop
              playsinline
              webkit-playinginline
              muted
              :style="{
              display: videoRange?.includes(index) ? 'unset' : 'none',
            }"
              :ref="index === 0 ? 'videoFirstRef' : undefined"
              draggable="false"
              @canplaythrough="
              isLoadEnoughVideo(
                isMobile ? video.srcMobile : video.src,
              )
            "
              @error="
              handErrorLoadVideo(
                $event,
                isMobile ? video.srcMobile : video.src,
              )
            "
              @click="
              videoClickHandler(
                isMobile ? video.srcMobile : video.src,
                index,
              )
            "
            >
              <source
                :src="video.src"
                type="video/mp4"
                :media="'(min-width: 1128px)'"
              />
              <source
                :src="video.srcMobile"
                type="video/mp4"
                :media="'(max-width: 1128px)'"
              />
            </video>
          </div>
          <div v-else-if="acitveTypeItems === 'images'" class="images">
            <div v-for="(image, index) in activeItemSlide">
              <div
                class="loader__wrapper"
                :key="image.src[0]"
                :style="{
                left: `calc(${index * firstImgWidth + 'px'}`,
                zIndex: loadImageForStart[image.src] ? -1 : -1,
              }"
              >
                <UiLoader
                  :radius="10"
                  color="var(--var-blue-100)"
                  :circle-width="2"
                />
              </div>
            </div>
            <img
              v-for="(images, index) in activeItemSlide"
              :id="images.src"
              @click="openInFullSizeHandler(images.src, index)"
              :key="images.src"
              :src="images.src"
              :ref="index === 0 ? 'videoFirstRef' : undefined"
              :class="{
              'gallery-video-loop_first': index === 0,
              'gallery-video-loop': true,
            }"
              @load="imageLoadHandler(images.src)"
            />
          </div>
          <div v-else-if="acitveTypeItems === 'tour'">
            <div class="gallery-carusel-wrp">
              <div class="panorama-wrp">
                <iframe
                  class="panorama-item"
                  :src="baseUrl + activeItemSlide[0].src"
                  height="100%"
                  style="width: 100%"
                  @load="loadTourHandler(activeItemSlide[0].src)"
                />
              </div>
            </div>
          </div>
          <div v-else-if="acitveTypeItems === 'specif'">
            <object
              :data="image.src"
              type="application/pdf"
              v-for="(image, indexSpecif) in activeItemSlide"
              :id="image.src"
              :ref="indexSpecif === 0 ? 'videoFirstRef' : undefined"
              :key="image.src"
              class="specif-item__pdf"
            />
          </div>
        </div>
        <div class="carousel-wrapper__nav-container" v-if="activeItemSlide.length > 1">
          <svg
            v-for="(item, index) in activeItemSlide"
            @click="chooseItemActive(item.src, index)"
            class="carousel-wrapper__nav-container__item"
            :class="{'nav_active': choosenItem === index}"
            width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" stroke="#E1E5F0"/>
            <circle cx="7" cy="7" r="6" fill-opacity="0.2"/>
          </svg>
        </div>
      </div>
    </div>
    <UiModalsFullScreenModalV3
      v-if="isOpenFullScreenModal"
      :typeItems="acitveTypeItems"
      :items="activeItemSlide"
      :posters="posters"
      :item-active="currentIndexFullScreenImg"
      :is-need-additional-block="false"
      @close-action="closeActionHandler"
      bg-color="transparent"
    />
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import {useRuntimeConfig} from '#imports';
import {useBaseStore} from '~/modules/BaseModule/base.store';

const props = withDefaults(
  defineProps<{
    items: {
      id: number;
      title: string;
      subtitle: string;
      type: string;
      items: {
        src: string;
        srcMobile?: string;
      }[];
    }[];
    posters?: { videoSrc: string; value: string }[];
  }>(),
  {},
);
const runtimeConfig = useRuntimeConfig();
const variantItemSlide = ref(props.items);
const activeItemSlide = ref(props.items[0].items);
const acitveTypeItemsIndex = ref(0);
const acitveTypeItems = ref<string>('images');
const base = useBaseStore();
const isMobile = computed(() => base.isMobile);
const baseUrl = runtimeConfig.public.vueAppBaseUrl;
const videoRange = ref<null | number[]>(null);
const loadVideoForStart = ref<{ [key: string]: boolean }>({});
const loadImageForStart = ref<{ [key: string]: boolean }>({});
const loadTourForStart = ref<{ [key: string]: boolean }>({});
const videoSliderRef = ref(null);
const videoFirstRef = ref(null);
const iconLeft = ref(null);
const iconRight = ref(null);
const currentIndexFullScreenImg = ref(0);
const currentWidth = computed(() => base.currentWidth);

let positionDiff: number;
let firstImgWidth: number;
let isDragStart = false;
let prevPageX: number;
let prevScrollLeft: number;
let scrollWidth: number;
let isDragging = false;
let timer = null;
const choosenItem = ref(0);
const isCanSlide = ref(true);
const isOpenFullScreenModal = ref(false);

const chooseFormat = (activeItem: string, index: number) => {
  acitveTypeItems.value = activeItem;
  acitveTypeItemsIndex.value = index;
};

const closeActionHandler = () => {
  isOpenFullScreenModal.value = false;
};

const isCanControlVideo = ref<{ [name: string]: boolean }>({});

const startAutoScroll = () => {
  clearInterval(timer);

  timer = setInterval(() => {
    const currentIndex = choosenItem.value;
    const nextIndex = (currentIndex + 1) % activeItemSlide.value.length;
    chooseItemActive(activeItemSlide.value[nextIndex].src, nextIndex, false);
  }, 6000);
};

const stopAutoScroll = () => {
  clearInterval(timer);
};

const videoClickHandler = async (video: string, index: number) => {
  if (!isDragging) {
    // setTimeout(() => {
    if (!isMobile.value) {
      openInFullSizeHandler(video, index);
    }
    isCanControlVideo.value = {
      [video]: !isCanControlVideo.value[video],
    };
    if (!isCanControlVideo.value[video]) {
      await document.getElementById(video)?.play();
    }
    // }, 100);
  }
};

const videoFocusHandler = (e: any, video: string) => {
  // console.log(e);
  // console.log(e.layerY);
  // console.log(e.srcElement.clientHeight);
  const currentPosition = e?.layerY > 0 ? e?.layerY : 1;
  const currentHeightItem = e?.srcElement?.clientHeight;
  // console.log((currentPosition / currentHeightItem) * 100);

  if ((currentPosition / currentHeightItem) * 100 > 30) {
    isCanControlVideo.value = {[video]: true};
  }
  // console.log(video);
  // isCanControlVideo.value = {[video]: true}
};

const openInFullSizeHandler = (item: string, index: number) => {
  if (!isDragging) {
    currentIndexFullScreenImg.value = index;
    isOpenFullScreenModal.value = true;
  }
};

const loadTourHandler = (currentTour: string) => {
  loadTourForStart.value = {
    ...loadTourForStart.value,
    [currentTour]: true,
  };
};

const imageLoadHandler = (currentImage: string) => {
  loadImageForStart.value = {
    ...loadImageForStart.value,
    [currentImage]: true,
  };
};

const isLoadEnoughVideo = (currentVideo: string) => {
  loadVideoForStart.value = {
    ...loadVideoForStart.value,
    [currentVideo]: true,
  };
};

const intervalLoadRef = ref<any>(null);

const handErrorLoadVideo = (e, video?: string) => {
  if (video) {
    const brokeVideo: HTMLVideoElement | null =
      document.getElementById(video) as HTMLVideoElement;
    if (brokeVideo) {
      // if (intervalLoadRef.value) {
      //   clearTimeout(intervalLoadRef.value);
      //   intervalLoadRef.value = null;
      // }
      intervalLoadRef.value = setTimeout(async () => {
        brokeVideo.pause();
        brokeVideo.load();
        // await brokeVideo.play();
      }, 3000);
    }
  }
};

const showHideIcons = (isNeedChoosenItem?: boolean) => {
  if (videoSliderRef.value) {
    if (!isNeedChoosenItem) {
      choosenItem.value = Math.round(
        videoSliderRef.value.scrollLeft / firstImgWidth,
      );
    }

    if (iconLeft.value) {
      iconLeft.value.style.display =
        videoSliderRef.value.scrollLeft <= 120 ? 'none' : 'block';
    }

    if (iconRight.value) {
      iconRight.value.style.display =
        videoSliderRef.value.scrollLeft + 20 >= scrollWidth
          ? 'none'
          : 'block';
    }
  }
};

const changeSlideLeft = () => {
  if (videoSliderRef.value && isCanSlide.value) {
    isCanSlide.value = false;
    videoSliderRef.value.scrollLeft += -firstImgWidth;
    setTimeout(() => {
      showHideIcons();
      isCanSlide.value = true;
    }, 600);
  }
};

const changeSlideRight = () => {
  // if (videoRange.value?.length !== props.items?.length) {
  //   videoRange.value = Array.from(Array(props.items.length).keys());
  // }
  if (acitveTypeItems.value === 'video') {
    activeItemSlide.value.forEach((video, index) => {
      const videoTag = document.getElementById(video[0]);
      if (!videoTag?.src) {
        const videoSplit = video[0].split('.');
        videoTag.src = isMobile.value
          ? `${videoSplit[0]}.${videoSplit[1]}_mobile.${videoSplit[2]}`
          : video[0];
      }
    });
  }

  if (videoSliderRef.value && isCanSlide.value) {
    isCanSlide.value = false;
    videoSliderRef.value.scrollLeft += firstImgWidth;
    setTimeout(() => {
      showHideIcons();
      isCanSlide.value = true;
    }, 600);
  }
};

const chooseItemActive = (activeItem: string, index: number, autoScrollReset: boolean = true) => {
  if (autoScrollReset) startAutoScroll();

  choosenItem.value = index;
  const choosenItemById = document.getElementById(activeItem);
  if (acitveTypeItems.value === 'video') {
    const videoSplit = activeItem.split('.');
    if (!choosenItemById?.src) {
      choosenItemById.src = isMobile.value
        ? `${videoSplit[0]}.${videoSplit[1]}_mobile.${videoSplit[2]}`
        : activeItem;
      setTimeout(async () => {
        await choosenItemById.play();
      }, 3000);
    }
  }

  if (choosenItemById) {
    new Promise((res) => {
      if (videoSliderRef.value) {
        videoSliderRef.value.scrollLeft = choosenItemById?.offsetLeft;
      }
      res('');
    }).then(() => {
      setTimeout(() => {
        showHideIcons(true);
      }, 1300);
    });
  }
};
const dragging = (e) => {
  if (videoSliderRef.value) {
    if (!isDragStart) return;

    if (currentWidth.value > 850) {
      e.preventDefault();
    }

    isDragging = true;
    videoSliderRef.value.classList.add('dragging');
    positionDiff = (e.pageX || e.touches[0].pageX) - prevPageX;
    videoSliderRef.value.scrollLeft = prevScrollLeft - positionDiff;
  }
};
const autoSlide = () => {
  // if (videoRange.value?.length !== props.items?.length) {
  //   videoRange.value = Array.from(Array(props.items.length).keys());
  // }
  if (
    (videoSliderRef.value &&
      videoSliderRef.value.scrollLeft -
      (videoSliderRef.value.scrollWidth -
        videoSliderRef.value.clientWidth) >
      -1) ||
    (videoSliderRef.value && videoSliderRef.value.scrollLeft <= 0)
  ) {
    return;
  }
  positionDiff = Math.abs(positionDiff);
  const additionalValueML = isMobile.value ? 10 : 14;
  let firstImgWidth =
    videoSliderRef.value.clientWidth + additionalValueML;
  let valDifference = firstImgWidth - positionDiff;

  if (
    videoSliderRef.value &&
    videoSliderRef.value.scrollLeft > prevScrollLeft
  ) {
    return (videoSliderRef.value.scrollLeft +=
      positionDiff > firstImgWidth / 5
        ? valDifference
        : -positionDiff);
  }
  if (videoSliderRef.value) {
    return (videoSliderRef.value.scrollLeft -=
      positionDiff > firstImgWidth / 5
        ? valDifference
        : -positionDiff);
  }
};

const dragStart = (e) => {
  stopAutoScroll();
  if (videoSliderRef.value) {
    isDragStart = true;
    prevPageX = e.pageX || e.touches[0].pageX;
    prevScrollLeft = videoSliderRef.value.scrollLeft;
  }
};
const dragStop = (e) => {
  startAutoScroll();
  isDragStart = false;
  // if (videoRange.value?.length !== props.items?.length) {
  //   videoRange.value = Array.from(Array(props.items.length).keys());
  // }
  if (videoSliderRef.value) {
    videoSliderRef.value.classList.remove('dragging');
    if (!isDragging) return;
    setTimeout(() => {
      isDragging = false;
    }, 0);
    new Promise((res, rej) => {
      const afterSlide = autoSlide();
      if (afterSlide % firstImgWidth !== 0) {
        videoSliderRef.value.scrollLeft =
          firstImgWidth *
          Math.round(videoSliderRef.value.scrollLeft / firstImgWidth);
      }
      res('');
    }).then(() => {
      setTimeout(() => {
        showHideIcons();
      }, 600);
    });
  }
};

watch(
  () => [acitveTypeItems.value, isMobile.value],
  () => {
    activeItemSlide.value =
      props.items[acitveTypeItemsIndex.value].items;
    if (videoSliderRef.value) {
      if (acitveTypeItems.value === 'video') {
        videoRange.value = Array.from(
          Array(activeItemSlide.value.length).keys(),
        );
      } else {
        loadVideoForStart.value = {};
      }
      videoSliderRef.value.scrollLeft = 0;
      setTimeout(() => {
        const additionalValueML = isMobile.value ? 10 : 14;
        firstImgWidth =
          videoSliderRef.value.clientWidth + additionalValueML;
        scrollWidth =
          videoSliderRef.value.scrollWidth -
          videoSliderRef.value.clientWidth;
      }, 100);
      setTimeout(() => {
        showHideIcons();
      }, 600);
    }
  },
);

const resizeHandler = () => {
  if (videoFirstRef.value) {
    const additionalValueML = isMobile.value ? 10 : 14;
    firstImgWidth =
      videoSliderRef.value.clientWidth + additionalValueML;
    const afterSlide = autoSlide();
    if (afterSlide % firstImgWidth !== 0) {
      videoSliderRef.value.scrollLeft =
        firstImgWidth *
        Math.round(videoSliderRef.value.scrollLeft / firstImgWidth);
    }
  }
};

onMounted(() => {
  startAutoScroll();
  videoRange.value = Array.from(
    Array(activeItemSlide.value.length).keys(),
  );
  if (videoSliderRef.value) {
    const additionalValueML = isMobile.value ? 10 : 14;
    firstImgWidth =
      videoSliderRef.value.clientWidth + additionalValueML;
    scrollWidth =
      videoSliderRef.value.scrollWidth -
      videoSliderRef.value.clientWidth;
  }

  setTimeout(() => {
    showHideIcons();
  }, 60);

  window.onresize = resizeHandler;
});
onUnmounted(() => {
  stopAutoScroll();
  window.onresize = null;
});
</script>

<style scoped lang="scss">
.gallery-carusel-wrp {
  .panorama-wrp {
    width: 100%;
    max-height: 450px;
    //background: var(--var-video-bg-video);
    .panorama-item {
      height: 450px;
      border-radius: 8px;
      border: none;

      @media (max-width: $md) {
        height: 100%;
        min-height: 225px;
      }
    }
  }
}

.images__wrapper {
  position: relative;
  height: fit-content;
  min-height: 55px;

  .loader__wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;

    @media (max-width: $lg) {
      display: none;
    }
  }
}

.images__wrapper-video {
  position: relative;
  height: fit-content;
  min-height: 55px;

  svg {
    position: absolute;
    top: 24%;
    left: 30%;
    height: 30px;
    cursor: pointer;
  }

  .loader__wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;
  }
}

.gallery-carusel-wrp {
  display: flex;
  gap: 16px;

  @media (max-width: $lg) {
    flex-direction: column;
  }

  @media (max-width: 900px) {
    .gallery-carusel-wrp {
      .panorama-wrp {
        .panorama-item {
          border-radius: 8px;
          border: none;
        }

        .panorama-item {
          width: 100%;
        }
      }
    }
  }
}

.wrapper {
  max-width: 100vw;
  width: 100%;
  display: flex;
  gap: $g-6;

  .wrapper-description {
    position: relative;
    width: 100%;
    border-radius: $br-14;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: $g-10;
  }

  .content__description {
    padding: $p-0;
    z-index: 100;

    .author-btns {
      position: absolute;
      bottom: 0px;
      color: white;
      left: 50%;
      transform: translateX(-50%);
    }

    .description__wrapper {
      display: grid;
      gap: $g-10;
      grid-template-columns: 1fr 1fr 1fr 1fr;

      .card {
        cursor: pointer;
        border-radius: $br-4;
        padding: $p-4;
        width: 100%;
        border: 1px solid var(--var-white-000);

        &_active {
          background-color: var(--var-white-200);
        }

        .number {
          margin-bottom: $m-4;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: var(--var-blue-300);
          width: 48px;
          height: 48px;
          border-radius: 50%;

          span {
            @include title-fs-28-fw-700-blue-100;
            color: var(--var-white-000);
          }
        }

        .title {
          @include headline-h4;
          color: var(--var-black-100);
          margin-bottom: $m-2;
        }

        .subtitle {
          @include launcher-p1;
        }

        @media (max-width: $md) {
          margin-bottom: 0px;
        }

        &:hover {
          border: 1px solid var(--var-white-400);
        }
      }

      @media (max-width: $lg) {
        grid-template-columns: 1fr 1fr;
        gap: $g-5;
        .card {
          display: grid;
          align-items: center;
          grid-template-columns: min-content 1fr;
          column-gap: $g-2;

          .subtitle {
            grid-column: 1 / 3;
          }
        }
      }
      @media (max-width: $md) {
        grid-template-columns: 1fr;
        gap: $g-1;
        .card {
          padding: $p-3;
        }
      }
    }

    @media (max-width: $md) {
      padding: $p-0;
      position: unset;
      background: unset;

      h3 {
        color: var(--var-black-100);
      }
      p {
        color: var(--var-black-100);
        margin-bottom: $m-5;
      }
    }
  }

  &__btn-left {
    left: 12px;
    display: none;
    justify-content: center;
    align-items: center;
  }

  &__btn-right {
    right: 290px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 1100px) {
      left: 780px;
    }
    @media (max-width: 900px) {
      right: 12px;
      left: auto;
    }
  }

  &__right-bar {
    min-width: 100px;
    max-width: 100px;
    display: flex;
    flex-direction: column;
    gap: $g-4;

    video {
      width: 100px;
      min-height: 55px;
      border-radius: $br-1;
      cursor: pointer;
    }

    img {
      width: 100px;
      min-height: 55px;
      border-radius: $br-1;
      cursor: pointer;
    }

    .item_active {
      border-radius: $br-2;
      border: 5px solid var(--var-blue-100);
      height: fit-content;
    }
  }

  .carousel-wrapper {
    position: relative;

    &__nav-container {
      position: absolute;
      z-index: 1000;
      width: 100%;
      left: 0;
      bottom: 0;

      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;

      box-sizing: border-box;
      padding-bottom: 8px;

      &__item {
        cursor: pointer;
      }
    }

    .nav_active {
      fill: #FFFFFF;
    }
  }

  .carousel {
    position: relative;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    scroll-behavior: smooth;
    border-radius: $br-3;

    .specif-item {
      max-height: 450px;
      overflow-y: auto;
      margin-right: $m-2;
      margin-left: $m-2;

      &__pdf {
        width: 100%;
        min-height: 450px;
      }

      &__img {
        height: 100%;

        @media (max-width: $md) {
        }
      }
    }

    .video {
      position: relative;
      max-height: 450px;
      background: var(--var-video-bg-video);

      .loader__wrapper {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
      }

      @media (max-width: $md) {
        background: transparent;
      }
    }

    .images {
      position: relative;
      background: var(--var-video-bg-video);
      max-height: 450px;

      .loader__wrapper {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: -1;
      }

      @media (max-width: $md) {
        background: transparent;
      }
    }

    img {
      height: 450px;
      width: calc(100% / 1);
      object-fit: cover;
      margin-left: $m-3;
      border-radius: $br-3;

      &:first-child {
        margin-left: 0px;
      }

      @media (max-width: $lg) {
        width: calc(100% / 1);
      }
      @media (max-width: $md) {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }

    video {
      height: 450px;
      width: calc(100% / 1);
      object-fit: cover;
      border-radius: $br-3;

      @media (max-width: $lg) {
        width: calc(100% / 1);
      }
      @media (max-width: $md) {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }

    .gallery-video-loop {
      margin-left: 14px;

      &_first {
        margin-left: 0px;
      }

      @media (max-width: $md) {
        margin-left: 10px;
        &_first {
          margin-left: 0px;
        }
      }
    }
  }

  .dragging {
    scroll-behavior: auto;

    video::-webkit-media-controls {
      display: none; // Стандартные элементы управления отключены.
    }

    &img {
      pointer-events: none;
      cursor: grab !important;
    }
  }
}

.dragging {
  video {
    cursor: grabbing !important;
  }

  img {
    cursor: grabbing !important;
  }
}

h3 {
  @include headline-h3;
  margin: 0px;
  color: var(--var-white-000);
}

p {
  @include launcher-p2;
  margin: $m-4 0px 0px 0px;
  color: var(--var-white-000);
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  line-clamp: 3;
  -webkit-box-orient: vertical;

  @media (max-width: $md) {
    margin: $m-2 0px $m-1 0px;

    -webkit-line-clamp: unset; /* number of lines to show */
    line-clamp: unset;
    -webkit-box-orient: vertical;
  }
}
</style>
